import { Component, OnInit, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AiMarketingService } from '@admin-core/services/ai-marketing.service';
import { AiOrganicPost } from '@admin-core/models/ai-marketing.model';
import { TranslatePipe } from '@admin-core/i18n/translate.pipe';
import { TranslationKey } from '@admin-core/i18n/translations/en';
import { AiMarketingFeatureHeaderComponent } from './ai-marketing-feature-header.component';

@Component({
  selector: 'app-ai-marketing-organic',
  standalone: true,
  imports: [TranslatePipe, DatePipe, AiMarketingFeatureHeaderComponent],
  templateUrl: './ai-marketing-organic.component.html',
  styleUrl: './ai-marketing-admin.scss'
})
export class AiMarketingOrganicComponent implements OnInit {
  private readonly api = inject(AiMarketingService);

  readonly posts = signal<AiOrganicPost[]>([]);
  readonly loading = signal(false);
  readonly loadError = signal<string | null>(null);

  ngOnInit(): void {
    this.reload();
  }

  reload(): void {
    this.loading.set(true);
    this.loadError.set(null);
    this.posts.set([]);

    this.api.getOrganic().subscribe({
      next: (r) => {
        this.posts.set(r.items ?? []);
        this.loading.set(false);
      },
      error: () => {
        this.posts.set([]);
        this.loading.set(false);
        this.loadError.set('load');
      }
    });
  }

  statusKey(status: string): TranslationKey {
    return `aiMarketing.organic.status.${status}` as TranslationKey;
  }

  platformKey(platform: string): TranslationKey {
    return `aiMarketing.platform.${platform}` as TranslationKey;
  }

  assetUrl(post: AiOrganicPost): string | null {
    if (post.creativeType === 'Video') {
      return post.creativeUrl ?? null;
    }

    return post.creativeThumbnailUrl || post.creativeUrl || null;
  }

  isVideo(post: AiOrganicPost): boolean {
    return post.creativeType === 'Video';
  }

  displayDate(post: AiOrganicPost): string {
    return post.publishedAt ?? post.createdAt;
  }
}
